export default {
	computed: {
		actionPositionAbsolute() {
			if (this.actionPosition === 'absolute') {
				return true
			} else {
				return false
			}
		},

		actionPositionFixed() {
			if (this.actionPosition === 'fixed') {
				return true
			} else {
				return false
			}
		},

		countSelected() {
			return this.selected.length
		},

		fieldDefs() {
			return this.infoData.fieldDefs
		}
	},

	watch: {
		selected: {
			handler() {
				this.selected.length > 0 ? (this.disabled = false) : (this.disabled = true)
			}
		}
	},

	methods: {
		toggleAll() {
			if (this.selected.length) {
				this.selected = []
			} else {
				this.selected = this.items.slice()
			}
		},

		getSpeedDialOptions(key) {
			if (this.speedDialOptions && this.speedDialOptions[key]) {
				return this.speedDialOptions[key]
			} else return false
		},

		changeSort(header) {
			if (typeof header.sortable === 'undefined' || header.sortable) {
				let column = header.value
				if (this.pagination.sortBy === column) {
					this.pagination.descending = !this.pagination.descending
				} else {
					this.pagination.sortBy = column
					this.pagination.descending = false
				}
			}
		},

		deleteModels() {
			let ids = []
			this.selected.forEach(function(element, i) {
				ids[i] = element.id
			})

			this.axios.post(this.modelDef + '/delete', { ids: ids }).then(response => {
				// get body data
				let data = response.data
				this.disabled = true
				this.selected = []
				this.getDataFromApi()
				this.confirmDelete = false
				let snackmessage = ''
				let snackcolor = ''
				if (data.status == 'message') {
					snackmessage = data.message
					snackcolor = data.type
				} else {
					snackmessage = 'Elementi eliminati con successo.'
					snackcolor = 'success'
				}
				this.$store.commit('setSnackbar', {
					timeout: 6000,
					text: snackmessage,
					value: true,
					color: 'success'
				})
			},
			response => {
				// error callback
			})
		}
	}
}
